import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form", "modal"]

    showWarningPopup(event) {
        event.preventDefault()

        const createAccountForm = document.querySelector('#create-account-form')
        if (createAccountForm) {
            createAccountForm.style.visibility = 'hidden'
        }

        const template = document.querySelector('#cancel-warning-template')
        if (!template) {
            console.error('Cancel warning template not found')
            return
        }

        const popupElement = template.content.cloneNode(true)
        const popup = popupElement.querySelector('.form-bg')
        
        document.body.appendChild(popupElement)

        const discardBtn = popup.querySelector('#discardBtn')
        const goBackBtn = popup.querySelector('#goBackBtn')

        discardBtn.addEventListener('click', () => {
            if (createAccountForm) {
                createAccountForm.remove()
            }

            popup.remove()

            location.reload(true)
        })

        goBackBtn.addEventListener('click', () => {
            if (createAccountForm) {
                createAccountForm.style.visibility = 'visible'
            }

            popup.remove()
        })
    }
}

